import { getFriendlyName } from 'Utils/FriendlyName'

const getAWSPayload = (fields) => {
  const AwsSpec = {
    Account: {
      RefID: fields.Account,
      RefKind: 'Account'
    },
    UserName: fields.UserName
  }
  return AwsSpec
}
const getAZUREPayload = (fields) => {
  const AzureSpec = {
    Account: {
      RefID: fields.Account,
      RefKind: 'Account'
    },
    DisplayName: fields.DisplayName
  }
  return AzureSpec
}
const getGCPPayload = (fields) => {
  const GcpSpec = {
    Project: {
      RefID: fields.Project,
      RefKind: 'Project'
    },
    Name: fields.Name,
    Description: fields.Description
  }
  return GcpSpec
}

export const getServiceAccountPayload = (fields) => {
  const payload = {
    ObjectMeta: {
      Name: getFriendlyName()
    },
    Spec: {
      Type: fields.accountType,
      EncKey: fields.EncKey
    }
  }
  if (fields.accountType === 'AWS') {
    payload.Spec.AwsSpec = getAWSPayload(fields)
  }
  if (fields.accountType === 'AZURE') {
    payload.Spec.AzureSpec = getAZUREPayload(fields)
  }
  if (fields.accountType === 'GCP') {
    payload.Spec.GcpSpec = getGCPPayload(fields)
  }
  return payload
}

export const getRequestPayload = (fields, user) => {
  const name = getFriendlyName()
  const payload = {
    ObjectMeta: {
      Name: name
    },
    Spec: {
      Justification: fields.Comment,
      RequestedFor: {
        ObjectRef: [
          {
            RefKind: 'User',
            RefID: user.ObjectMeta.ID
          }
        ]
      },
      SvcAccSpec: {
        Type: fields.accountType,
        EncKey: fields.EncKey
      }
    },
    Status: 'New',
    GivenName: fields.GivenName,
    Type: 'ServiceAccount'
  }
  if (fields.accountType === 'AWS') {
    payload.Spec.SvcAccSpec.AwsSpec = getAWSPayload(fields)
  }
  if (fields.accountType === 'AZURE') {
    payload.Spec.SvcAccSpec.AzureSpec = getAZUREPayload(fields)
  }
  if (fields.accountType === 'GCP') {
    payload.Spec.SvcAccSpec.GcpSpec = getGCPPayload(fields)
  }
  return payload
}
